import styled from 'styled-components'

export const Content = styled('div')`
  .heading-section {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .navigation .breadcrumbs {
      padding: 0;

      .breadcrumb-link,
      .breadcrumb-text,
      .breadcrumb-link span,
      .breadcrumb-text span {
        font-size: 14px;
      }
    }
  }
`

export const Root = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 52px;
`

export const Strong = styled('span')`
  font-weight: bold;
`
